import { ReportsFilters } from '@mobileTypes'

const UNQUOTED_VALUE = /^[A-Za-z0-9._:T+-]+$/

export const quoteRsqlValue = (value: string): string => {
  if (UNQUOTED_VALUE.test(value)) {
    return value
  }

  return `"${value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`
}

const toIso = (localDateTime: string): string => {
  const date = new Date(localDateTime)

  if (Number.isNaN(date.getTime())) {
    return localDateTime
  }

  return date.toISOString()
}

export const buildReportsRsql = (filters: ReportsFilters): string | undefined => {
  const parts: string[] = []

  if (filters.os) {
    parts.push(`device.os==${filters.os}`)
  }

  if (filters.configId.trim()) {
    parts.push(`app.configId==${quoteRsqlValue(filters.configId.trim())}`)
  }

  if (filters.triggerKind.trim()) {
    parts.push(`trigger.kind==${quoteRsqlValue(filters.triggerKind.trim())}`)
  }

  if (filters.message.trim()) {
    parts.push(`trigger.message=like=${quoteRsqlValue(`*${filters.message.trim()}*`)}`)
  }

  if (filters.from) {
    parts.push(`occurredAt=ge=${quoteRsqlValue(toIso(filters.from))}`)
  }

  if (filters.to) {
    parts.push(`occurredAt=le=${quoteRsqlValue(toIso(filters.to))}`)
  }

  return parts.length > 0 ? parts.join(';') : undefined
}
